import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";

import type { EmailVerificationStatus } from "./index";

type EmailVerificationProps = {
  status: EmailVerificationStatus;
  disabled?: boolean;
  onSubmit: () => void;
  onSetOwnPassword?: () => void;
  t: any;
};

const DefaultEmailVerification: React.FC<EmailVerificationProps> = ({
  status,
  disabled,
  onSubmit,
  onSetOwnPassword,
  t,
}) => {
  return (
    <div
      className="vh-100 d-flex align-items-center"
      style={{ background: "white" }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6}>
            <div className="d-flex flex-column">
              <h5 className="text-center mb-3">
                {t(`emailVerification:${status}.title`)}
              </h5>
              <p className="text-center mb-3">
                {t(`emailVerification:${status}.subtitle`)}
              </p>
              <div className="d-flex justify-content-center flex-wrap">
                <Button
                  variant="primary"
                  className="m-1"
                  disabled={disabled}
                  onClick={onSubmit}
                >
                  {t(`emailVerification:${status}.button.submit`)}
                </Button>
                {onSetOwnPassword ? (
                  <Button
                    variant="outline-primary"
                    className="m-1"
                    onClick={onSetOwnPassword}
                  >
                    {t("emailVerification:button.setOwnPassword")}
                  </Button>
                ) : null}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DefaultEmailVerification;
